import React from 'react'
import { useDestroyDashboard } from 'api/hooks/use-dashboards'
import { useQueryClient } from 'react-query'
import ConfirmDelete from 'shared/confirm-delete'
import { useNavigate } from 'react-router-dom'
import { useFolderReturnPath } from 'dashboard/folders/folder-context'

function DeleteButton({ dashboardId }) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  // Deleting the view returns to the folder it was opened from, which is still there.
  const backPath = useFolderReturnPath()
  const { mutate } = useDestroyDashboard({
    id: dashboardId,
    options: {
      onSuccess: () => {
        navigate(backPath)
        queryClient.invalidateQueries('dashboards')
        queryClient.invalidateQueries('current-user')
      }
    }
  })

  const handleDelete = () => mutate()

  return (
    <ConfirmDelete
      id={dashboardId}
      handleDelete={handleDelete}
      extraConfirm={false}
      message="Are you sure you want to delete this view?"
    />
  )
}

export default DeleteButton
